<template>
  <h2 class="title">
    <slot>{{ local ? local : $route.name }}</slot>
  </h2>
</template>
<script>
export default {
  setup(props, context) {
    return {
      ...context.attrs
    }
  }
}
</script>
